import { useEffect, useRef } from "react";
import { Modal } from "bootstrap";

export default function NoticeModal({ selectedNotice, show, onClose }) {
  const modalRef = useRef(null);
  const modalInstance = useRef(null);

  const handleClose = () => {
    modalInstance.current?.hide();
  };

  useEffect(() => {
    if (!modalRef.current) return;

    if (show) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: true,
      });

      modalInstance.current.show();

      const handleHidden = () => {
        onClose?.();
      };

      // 이벤트 등록
      modalRef.current.addEventListener("hidden.bs.modal", handleHidden);

      // cleanup
      return () => {
        if (modalRef.current) {
          modalRef.current.removeEventListener("hidden.bs.modal", handleHidden);
        }
      };
    }
  }, [show]);

  return (
    <div className="modal fade" id="modalNotiView" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">
              {selectedNotice?.subject || "공지 제목"}
            </h5>
            <button className="btn-close" onClick={handleClose}></button>
          </div>

          <div className="modal-body">
            <p>{selectedNotice?.content || "내용 없음"}</p>
          </div>

          <div className="modal-footer">
            <button className="btn btn-lg btn-gray" onClick={handleClose}>
              닫기
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
